import { createReducer, on } from '@ngrx/store';
import { ArcHospiDto } from 'src/app/api/models';
import {
  admissionDateEnteredFailure, admissionDateEnteredSuccess, admissionDateIntervalErrorFailure,
  admissionDateIntervalErrorSuccess, agreementSignedFailure, agreementSignedSuccess, contractBlockedFailure,
  contractBlockedSuccess,
  contractInvalidFailure,
  contractInvalidSuccess,
hospitalSelectedFailure, hospitalSelectedSuccess,
  identificationFailure, identificationSuccess, medicalFormPrintedFailure,
  medicalFormPrintedSuccess, preHospiCompleteFailure, preHospiCompleteSuccess, preHospiOverwrittenFailure, resetArchospi, preHospiOverwrittenSuccess, questionnaireSelectedFailure, questionnaireSelectedSuccess, stopWithErrorFailure, stopWithErrorSuccess
} from './archospi.actions';


export const arcHospiFeatureKey = 'archospi';

export interface ArcHospiState {
  arcHospi: ArcHospiDto;

}

export const initialState: ArcHospiState = {
  arcHospi: undefined
};


export const arcHospiReducer = createReducer(
  initialState,

  on(identificationSuccess, stopWithErrorSuccess, agreementSignedSuccess, hospitalSelectedSuccess, admissionDateEnteredSuccess,
    questionnaireSelectedSuccess, preHospiCompleteSuccess, preHospiOverwrittenSuccess, medicalFormPrintedSuccess, admissionDateIntervalErrorSuccess,
    (state, { data }) => ({
      ...state,
      arcHospi: data
    })),

  on(contractBlockedSuccess, contractInvalidSuccess,
    (state, { data }) => ({
      ...state,
      arcHospi: data
    })),

  on(identificationFailure, stopWithErrorFailure, agreementSignedFailure, hospitalSelectedFailure, admissionDateEnteredFailure,
    questionnaireSelectedFailure, preHospiCompleteFailure, preHospiOverwrittenFailure, medicalFormPrintedFailure, admissionDateIntervalErrorFailure,
    contractBlockedFailure, contractInvalidFailure,
    (state) => ({
      ...state,
      arcHospi: null,
    })),

    on(resetArchospi, () => initialState)

);

